import type Month from "entities/month";
import PayGateTransaction from "entities/payGateTransaction";
import type PayGateTransactionsFilter from "entities/filters/payGateTransactionsFilter";
import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import type { AxiosPromise } from "axios";

export default class TurnoverRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  async download({ year, month }: Month) {
    const response = await (this.callApi(
      api =>
        api.all("finance").all("monthly_turnovers").all("report").getRaw({
          year: year,
          month: month,
        }) as any,
      { ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }) }
    ) as AxiosPromise);

    return response.data;
  }

  getAllPayGateTransactions(filters: PayGateTransactionsFilter) {
    const fromMonth = filters.sinceDate.getMonth() + 1;
    const fromYear = filters.sinceDate.getFullYear();
    const toMonth = filters.untilDate.getMonth() + 1;
    const toYear = filters.untilDate.getFullYear();

    return this.callApi(api =>
      api
        .all("finance")
        .all("monthly_turnovers")
        .all("paygate_transaction_search")
        .postEntities<PayGateTransaction>({ fromMonth, fromYear, toMonth, toYear }, PayGateTransaction)
    );
  }
}
